module.exports = __webpack_public_path__ + "img/qy6.89c8a94e.jpg";